import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";
import { Provider } from "react-redux";
import store from "./store";
import PrivateRoute from "./components/private-route/PrivateRoute";
import Home from './components/home/Landing';
import SignIn from "./components/auth/SignIn";


if (localStorage.jwtToken) {

  const token = localStorage.jwtToken;
  setAuthToken(token);

  const decoded = jwt_decode(token);
  store.dispatch(setCurrentUser(decoded));

  const currentTime = Date.now() / 1000; 
  if (decoded.exp < currentTime) {

    store.dispatch(logoutUser());

    window.location.href = "./login";
  }
}
class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router>
          {/* <div className="App"> */}
            {/* <Route exact path="/register" component={SignInPage} /> */}
            <Route exact path="/login" component={SignIn} />
            <Switch>
              <PrivateRoute exact path="/" component={Home} />
            </Switch>
          {/* </div> */}
        </Router>
      </Provider>
    );
  }
}
export default App;